
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useListParticipationTypes = () => {
    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage } = useContext(MessageContext);
    const [ participationTypes, setParticipationTypes ] = useState([]);
    const [ fetchingParticipationTypes, setFetchingParticipationTypes ] = useState(true);

    /** list time of days
    * @param {string} sort - sort field 
    * @param {string} order - sort order (asc/desc) */ 
    const listParticipationTypes = async (sort='StartTime', order='asc') => {
        try {

            
            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);
            
            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            result = await Axios.get(rootPath + "/api/v1/participationtypes", options);

            
            if (result && result.status === 200) {
                setParticipationTypes(result.data);
                setFetchingParticipationTypes(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.participationTypesNotFound') });
                setFetchingParticipationTypes(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingParticipationTypesFailed') });
            setFetchingParticipationTypes(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingParticipationTypesFailed') });
            setFetchingParticipationTypes(false);
            return error;
        }
    }

    return { participationTypes, fetchingParticipationTypes, listParticipationTypes };
}

export default useListParticipationTypes;